"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Component = exports.Builder = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _jquery = _interopRequireDefault(require("jquery"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _reactRouterDom = require("react-router-dom");
var _PreviewWrapper = _interopRequireDefault(require("./PreviewWrapper"));
var _Print = _interopRequireDefault(require("./Print"));
var _Export = _interopRequireDefault(require("./Export"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _reactRedux = require("react-redux");
var _builder = require("../../reducers/builder.js");
var _player = require("../../reducers/player.js");
var _reactDndMultiBackend = require("react-dnd-multi-backend");
var _HTML5toTouch = _interopRequireDefault(require("../../HTML5toTouch.js"));
var _allElements = _interopRequireDefault(require("../../allElements.js"));
var _Elements = _interopRequireDefault(require("./Elements"));
var _Settings = _interopRequireDefault(require("./Settings"));
var _Trash = _interopRequireDefault(require("./Trash"));
var _FlowSettings = _interopRequireDefault(require("./FlowSettings"));
var _Variables = _interopRequireDefault(require("./Variables"));
var _TextToSpeech = _interopRequireDefault(require("./TextToSpeech"));
var _FlowList = _interopRequireDefault(require("./FlowList"));
var _builder2 = require("../../selectors/builder.js");
var _helpers = require("../../other/helpers.js");
var _DataConnectorsPicker = _interopRequireDefault(require("../DataConnectorsPicker"));
var _ScrollShadow = _interopRequireDefault(require("../ScrollShadow"));
var _location = _interopRequireDefault(require("cccisd-icons/location"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _RestrictionsLevelContext = _interopRequireDefault(require("../../other/RestrictionsLevelContext.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Builder = /*#__PURE__*/function (_React$Component) {
  _inherits(Builder, _React$Component);
  var _super = _createSuper(Builder);
  function Builder() {
    var _this;
    _classCallCheck(this, Builder);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      builderHeight: null
    });
    _defineProperty(_assertThisInitialized(_this), "_handleUnload", function (event) {
      if (_this.props.isSaveNeeded) {
        var message = 'You have unsaved changes';
        event.returnValue = message;
        return message;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_handleResize", function (e) {
      if (!_this.refs.builder) {
        return;
      }
      var overlay = document.getElementById('cccisd-assignment-overlay');
      var marginBottom = overlay ? 2 * overlay.offsetTop : 16;
      var windowHeight = (0, _jquery["default"])(window).height();
      var builderOffset = (0, _jquery["default"])(_this.refs.builder).offset().top;
      var builderHeight = Math.max(windowHeight - builderOffset - marginBottom, 100);
      _this.setState({
        builderHeight: "".concat(builderHeight, "px")
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_changeToBriefMode", function (event) {
      if (event) {
        event.preventDefault();
      }
      _this.props.changeViewMode('brief');
    });
    _defineProperty(_assertThisInitialized(_this), "_changeToPreviewMode", function (event) {
      if (event) {
        event.preventDefault();
      }
      _this.props.changeViewMode('preview');
    });
    _defineProperty(_assertThisInitialized(_this), "_getAllowedElements", function () {
      var flowType = _this.props.flowSettings.type;
      if (!flowType) {
        return [];
      }
      var flowTypeInfo = (0, _helpers.getFlowTypes)()[flowType];
      if (!flowTypeInfo) {
        throw new Error("There is no flow type \"".concat(flowType, "\""));
      }
      var components = flowTypeInfo.components;
      if (!components) {
        throw new Error("There are no components for flow type \"".concat(flowType, "\""));
      }
      var filtered = _allElements["default"].filter(function (element) {
        if (!components.includes(element.code)) {
          return false;
        }

        // Don't allow report on the low levels
        if (['basic', 'premium'].includes(_this.props.restrictionsLevel)) {
          if (element.code === 'report') {
            return false;
          }
        }

        // Allow only some games to the premium restrictions
        if (_this.props.restrictionsLevel === 'premium') {
          var allowedGames = ['game_crooksandrobbers', 'game_bugzz', 'game_fireandice', 'game_runner', 'game_nottetris'];
          if (allowedGames.includes(element.code)) {
            return true;
          }
          if (/^game_/.test(element.code)) {
            return false;
          }
        }
        if (_this.props.restrictionsLevel === 'basic') {
          return !['dragdrop', 'list', 'menu', 'menuItem', /^game_/].some(function (type) {
            if (type instanceof RegExp && type.test(element.code)) {
              return true;
            }
            if (type === element.code) {
              return true;
            }
            return false;
          });
        }
        return true;
      });
      return (0, _sortBy2["default"])(filtered, [function (element) {
        return components.indexOf(element.code);
      }]);
    });
    _defineProperty(_assertThisInitialized(_this), "_getFlowPlayerType", function () {
      var flowType = _this.props.flowSettings.type;
      if (!flowType) {
        return null;
      }
      var flowTypeInfo = (0, _helpers.getFlowTypes)()[flowType];
      if (!flowTypeInfo) {
        throw new Error("There is no flow type \"".concat(flowType, "\""));
      }
      return flowTypeInfo.playerType;
    });
    _defineProperty(_assertThisInitialized(_this), "_getDataConnectorMeta", function (dataConnector) {
      if (dataConnector.category !== 'flow') {
        return null;
      }
      var element = _this.props.elements[dataConnector.id];
      if (!element) {
        return null;
      }
      var elementType = _allElements["default"].find(function (data) {
        return data.code === element.type;
      });
      var dataConnectors = elementType.getDataConnectors(element.settings);
      return dataConnectors[dataConnector.name] ? dataConnectors[dataConnector.name].meta : null;
    });
    _defineProperty(_assertThisInitialized(_this), "scrollToCurrentElement", function (e) {
      e && e.preventDefault();
      if (_this.listScrollShadow) {
        _this.listScrollShadow.scrollToNode({
          nodeId: "component_wrapper_".concat(_this.props.currentElement.id)
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_getElements", function () {
      var ListComponent;
      var playerType = _this._getFlowPlayerType();
      if (playerType) {
        if (playerType === 'flow') {
          ListComponent = _FlowList["default"];
        } else {
          throw new Error("There is no list element for flow player type \"".concat(playerType, "\""));
        }
      }
      var currentElementType = (0, _find2["default"])(_allElements["default"], {
        code: _this.props.currentElement.type
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: "builder",
        className: _style["default"].builderWrapper,
        style: {
          height: _this.state.builderHeight
        }
      }, /*#__PURE__*/_react["default"].createElement(_ScrollShadow["default"], {
        className: _style["default"].componentsPane
      }, /*#__PURE__*/_react["default"].createElement(_Elements["default"], {
        elements: _this._getAllowedElements(),
        addElement: _this.props.addElement
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Trash["default"], {
        elements: _this.props.trash,
        elementTypes: _allElements["default"]
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].listPane
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].listToolbar
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: 'btn btn-default btn-sm ' + (_this.props.viewMode === 'brief' && 'active'),
        onClick: _this._changeToBriefMode,
        title: "Switch to brief mode"
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "glyphicon glyphicon-align-justify"
      })), /*#__PURE__*/_react["default"].createElement("a", {
        className: 'btn btn-default btn-sm ' + (_this.props.viewMode === 'preview' && 'active'),
        onClick: _this._changeToPreviewMode,
        title: "Switch to preview mode"
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "glyphicon glyphicon-list-alt"
      })))), /*#__PURE__*/_react["default"].createElement(_ScrollShadow["default"], {
        id: "flow_element_list",
        className: _style["default"].listContent,
        ref: function ref(item) {
          _this.listScrollShadow = item;
        }
      }, ListComponent && /*#__PURE__*/_react["default"].createElement(ListComponent, {
        elements: _allElements["default"],
        list: _this.props.list,
        dirtyElements: _this.props.dirtyElements,
        redoElements: _this.props.redoElements,
        newElements: _this.props.newElements,
        currentElement: _this.props.currentElement,
        changeCurrentElement: _this.props.changeCurrentElement,
        toggleElementPreview: _this.props.toggleElementPreview,
        viewMode: _this.props.viewMode,
        addElement: _this.props.addElement,
        moveElement: _this.props.moveElement,
        moveElementToTrash: _this.props.moveElementToTrash,
        moveElementFromTrash: _this.props.moveElementFromTrash,
        duplicateElement: _this.props.duplicateElement,
        undoChanges: _this.props.undoChanges,
        redoChanges: _this.props.redoChanges,
        flowSettings: _this.props.flowSettings,
        sectionCount: _this.props.sectionCount,
        completeSectionTree: _this.props.completeSectionTree,
        allQuestionStartNumbers: _this.props.allQuestionStartNumbers,
        verifyAndImportElements: _this.props.verifyAndImportElements,
        dynamicUserLists: _this.props.dynamicUserLists,
        dynamicUserListsValues: _this.props.dynamicUserListsValues,
        defaultValues: _this.props.defaultValues
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].settingsPane
      }, currentElementType && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].settingsTitleWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].settingsTitle
      }, currentElementType.icon && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].icon
      }, currentElementType.icon), currentElementType.name), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-default",
        onClick: _this.scrollToCurrentElement,
        title: "Scroll to the element",
        style: {
          padding: '4px 7px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_location["default"], null)))), /*#__PURE__*/_react["default"].createElement(_ScrollShadow["default"], {
        id: "flow_element_settings",
        className: _style["default"].settingsContent
      }, /*#__PURE__*/_react["default"].createElement(_Settings["default"], {
        key: _this.props.currentElement.id,
        elementTypes: _allElements["default"],
        elements: _this.props.elements,
        currentElement: _this.props.currentElement,
        getDataConnectorMeta: _this._getDataConnectorMeta,
        updateCurrentElementSettings: _this.props.updateCurrentElementSettings,
        currentPlayerTemplateName: _this.props.currentPlayerTemplateName,
        currentPlayerTemplateSettings: _this.props.currentPlayerTemplateSettings,
        dynamicUserLists: _this.props.dynamicUserLists,
        defaultValues: _this.props.defaultValues,
        showAdvancedSettings: _this.props.flowSettings.showAdvancedSettings,
        restrictionsLevel: _this.props.restrictionsLevel
      }))));
    });
    _defineProperty(_assertThisInitialized(_this), "_saveFlow", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _ref2,
        _ref2$showNotificatio,
        showNotification,
        _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref2$showNotificatio = _ref2.showNotification, showNotification = _ref2$showNotificatio === void 0 ? true : _ref2$showNotificatio;
            _context.next = 3;
            return _this.props.saveFlow(+_this.props.flowId, _this.props.codebookId);
          case 3:
            if (showNotification) {
              (0, _cccisdNotification["default"])('The flow has been saved');
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return _this;
  }
  _createClass(Builder, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        flow: {
          DataConnectorsPicker: _DataConnectorsPicker["default"],
          allowTts: this.props.restrictionsLevel !== 'basic'
        }
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.loadFlow(+this.props.flowId);
      this._handleResize();
      window.addEventListener('resize', this._handleResize);
      window.addEventListener('beforeunload', this._handleUnload);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._handleResize);
      window.removeEventListener('beforeunload', this._handleUnload);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.currentElement.id !== prevProps.currentElement.id || this.props.viewMode !== prevProps.viewMode) {
        this.scrollToCurrentElement();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      // Check if it's not test environment
      if (!this.props.addElement) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.props.loading
      }, /*#__PURE__*/_react["default"].createElement(_RestrictionsLevelContext["default"].Provider, {
        value: this.props.restrictionsLevel
      }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Prompt, {
        when: this.props.isSaveNeeded,
        message: function message() {
          return 'Your work is not saved! Are you sure you want to leave?';
        }
      }), this.props.showGoBackLink && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].linkBack
      }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        to: "/flow/admin"
      }, "Go back to flow list")), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].buttonArea
      }, this.props.showTitle && /*#__PURE__*/_react["default"].createElement("h2", null, this.props.flowSettings.name), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
        className: 'btn btn-sm ' + (this.props.isSaveNeeded ? 'btn-warning' : 'btn-default'),
        onClick: this._saveFlow
      }, "Save"), ' ', /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-default btn-sm"
        }, "Player settings"),
        title: "Player settings",
        size: "large"
      }, /*#__PURE__*/_react["default"].createElement(_FlowSettings["default"], {
        flowId: this.props.flowId,
        settings: this.props.flowSettings,
        updateData: this.props.updateSettings,
        flowPlayerType: this._getFlowPlayerType()
      })), ' ', this.props.restrictionsLevel !== 'basic' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-default btn-sm"
        }, "Speech"),
        title: "Text-to-Speech"
      }, /*#__PURE__*/_react["default"].createElement(_TextToSpeech["default"], {
        saveFlow: this._saveFlow,
        reloadFlow: function reloadFlow() {
          return _this2.props.loadFlow(+_this2.props.flowId);
        }
      })), ' ') : null, !['basic', 'premium'].includes(this.props.restrictionsLevel) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-default btn-sm"
        }, "Variables"),
        title: "Variables"
      }, /*#__PURE__*/_react["default"].createElement(_Variables["default"], {
        flowId: this.props.flowId,
        saveFlow: this._saveFlow
      })), ' '), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-default btn-sm"
        }, "Export"),
        title: "Export"
      }, /*#__PURE__*/_react["default"].createElement(_Export["default"], {
        flowId: this.props.flowId,
        topId: this.props.rootId
      })), ' ', /*#__PURE__*/_react["default"].createElement(_Print["default"], null), " ", /*#__PURE__*/_react["default"].createElement(_PreviewWrapper["default"], null))), this._getElements()));
    }
  }]);
  return Builder;
}(_react["default"].Component);
exports.Builder = Builder;
_defineProperty(Builder, "propTypes", {
  flowId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  codebookId: _propTypes["default"].number,
  loading: _propTypes["default"].bool,
  addElement: _propTypes["default"].func,
  moveElement: _propTypes["default"].func,
  moveElementToTrash: _propTypes["default"].func,
  moveElementFromTrash: _propTypes["default"].func,
  duplicateElement: _propTypes["default"].func,
  undoChanges: _propTypes["default"].func,
  redoChanges: _propTypes["default"].func,
  changeCurrentElement: _propTypes["default"].func,
  currentElementId: _propTypes["default"].number,
  currentElement: _propTypes["default"].object,
  changeViewMode: _propTypes["default"].func,
  toggleElementPreview: _propTypes["default"].func,
  updateAnswer: _propTypes["default"].func,
  setAnswerError: _propTypes["default"].func,
  loadFlow: _propTypes["default"].func,
  saveFlow: _propTypes["default"].func,
  verifyAndImportElements: _propTypes["default"].func,
  list: _propTypes["default"].object,
  elements: _propTypes["default"].object,
  trash: _propTypes["default"].array,
  flowSettings: _propTypes["default"].object,
  dirtyElements: _propTypes["default"].array,
  redoElements: _propTypes["default"].array,
  newElements: _propTypes["default"].array,
  updateCurrentElementSettings: _propTypes["default"].func,
  updateSettings: _propTypes["default"].func,
  currentPlayerTemplateName: _propTypes["default"].string,
  currentPlayerTemplateSettings: _propTypes["default"].object,
  viewMode: _propTypes["default"].string,
  isSaveNeeded: _propTypes["default"].bool,
  sectionCount: _propTypes["default"].number,
  completeSectionTree: _propTypes["default"].func,
  allQuestionStartNumbers: _propTypes["default"].object,
  rootId: _propTypes["default"].number,
  dynamicUserLists: _propTypes["default"].array,
  dynamicUserListsValues: _propTypes["default"].object,
  defaultValues: _propTypes["default"].array,
  showGoBackLink: _propTypes["default"].bool,
  showTitle: _propTypes["default"].bool,
  restrictionsLevel: _propTypes["default"].string
});
_defineProperty(Builder, "defaultProps", {
  showGoBackLink: false,
  showTitle: true
});
_defineProperty(Builder, "childContextTypes", {
  flow: _propTypes["default"].object
});
var Component = function Component(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactDndMultiBackend.DndProvider, {
    options: _HTML5toTouch["default"]
  }, /*#__PURE__*/_react["default"].createElement(Builder, props));
};
exports.Component = Component;
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    loading: state.flow.builder.loading,
    currentElementId: state.flow.builder.currentElementId,
    currentElement: (0, _builder2.getCurrentElement)(state.flow.builder),
    elements: state.flow.builder.elements,
    list: (0, _builder2.getElementTree)(state.flow.builder),
    trash: state.flow.builder.trash,
    flowSettings: state.flow.builder.settings,
    dirtyElements: (0, _builder2.getDirtyElements)(state.flow.builder),
    redoElements: (0, _builder2.getRedoElements)(state.flow.builder),
    newElements: (0, _builder2.getNewElements)(state.flow.builder),
    viewMode: state.flow.builder.viewMode,
    isSaveNeeded: (0, _builder2.getSaveNeeded)(state.flow.builder),
    sectionCount: (0, _builder2.getSectionCount)(state.flow.builder),
    allQuestionStartNumbers: (0, _builder2.getAllQuestionStartNumbers)(state.flow.builder),
    rootId: state.flow.builder.rootId,
    currentPlayerTemplateName: (0, _builder2.getCurrentPlayerTemplate)(state.flow.builder).name,
    currentPlayerTemplateSettings: (0, _builder2.getCurrentPlayerTemplate)(state.flow.builder).settings,
    dynamicUserLists: state.flow.builder.dynamicUserLists,
    dynamicUserListsValues: (0, _builder2.getFakeDynamicUserListsValues)(state.flow.builder),
    defaultValues: state.flow.builder.defaultValues
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, {
  updateCurrentElementSettings: _builder.updateCurrentElementSettings,
  updateSettings: _builder.updateSettings,
  addElement: _builder.addElement,
  moveElement: _builder.moveElement,
  moveElementToTrash: _builder.moveElementToTrash,
  moveElementFromTrash: _builder.moveElementFromTrash,
  duplicateElement: _builder.duplicateElement,
  undoChanges: _builder.undoChanges,
  redoChanges: _builder.redoChanges,
  changeCurrentElement: _builder.changeCurrentElement,
  changeViewMode: _builder.changeViewMode,
  toggleElementPreview: _builder.toggleElementPreview,
  updateAnswer: _player.updateAnswer,
  setAnswerError: _player.setAnswerError,
  saveFlow: _builder.saveFlow,
  completeSectionTree: _builder.completeSectionTree,
  loadFlow: _builder.loadFlow,
  verifyAndImportElements: _builder.verifyAndImportElements
})(Component);
exports["default"] = _default;